import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Drawer } from 'antd';
import {
  BankOutlined,
  UserOutlined,
  FileTextOutlined,
  RobotOutlined,
  FileSearchOutlined,
  BarChartOutlined,
  DesktopOutlined,
  ThunderboltOutlined,
  AuditOutlined,
  InfoCircleOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useIsMobile } from '@/hooks/useBreakpoint';

const { Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

const menuItems: MenuItem[] = [
  { key: '/companies', icon: <BankOutlined />, label: 'Companies' },
  { key: '/users', icon: <UserOutlined />, label: 'Users' },
  { key: '/surveytemplates', icon: <FileTextOutlined />, label: 'Survey Templates' },
  { key: '/ai-prompt', icon: <RobotOutlined />, label: 'AI Prompts' },
  { key: '/ai-template', icon: <RobotOutlined />, label: 'AI Templates' },
  { key: '/apilogs', icon: <FileSearchOutlined />, label: 'API Logs' },
  { key: '/usage-stats', icon: <BarChartOutlined />, label: 'Usage Stats' },
  { key: '/devices', icon: <DesktopOutlined />, label: 'Devices' },
  { key: '/processes', icon: <ThunderboltOutlined />, label: 'Processes' },
  { key: '/customer-access-logs', icon: <AuditOutlined />, label: 'Access Logs' },
  { key: '/templateInfo', icon: <InfoCircleOutlined />, label: 'Template Info' },
];

interface SidebarProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

export default function Sidebar({ mobileOpen, onMobileClose }: SidebarProps) {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();

  const selectedKey = '/' + location.pathname.split('/')[1];

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    navigate(key);
    if (isMobile && onMobileClose) {
      onMobileClose();
    }
  };

  const menuContent = (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[selectedKey]}
      items={menuItems}
      onClick={handleMenuClick}
    />
  );

  if (isMobile) {
    return (
      <Drawer
        placement="left"
        open={mobileOpen}
        onClose={onMobileClose}
        width={260}
        styles={{ body: { padding: 0, background: '#001529' }, header: { background: '#001529', borderBottom: '1px solid rgba(255,255,255,0.1)' } }}
        closeIcon={<CloseOutlined style={{ color: '#fff' }} />}
        title={<span style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>Zonka Admin</span>}
      >
        {menuContent}
      </Drawer>
    );
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      trigger={null}
      width={220}
      style={{ background: '#001529', minHeight: '100vh' }}
    >
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'space-between',
          padding: collapsed ? 0 : '0 16px',
          color: '#fff',
        }}
      >
        {!collapsed && <span style={{ fontSize: 18, fontWeight: 600 }}>Zonka Admin</span>}
        <span
          onClick={() => setCollapsed(!collapsed)}
          style={{ cursor: 'pointer', fontSize: 18, color: '#fff' }}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </span>
      </div>
      {menuContent}
    </Sider>
  );
}
